import React from "react";
import { cn } from "../lib/utils";

const STATUS_JEMAAT = {
  Aktif: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Tidak Aktif": "bg-amber-50 text-amber-700 border-amber-200",
  Pindah: "bg-sky-50 text-sky-700 border-sky-200",
  Meninggal: "bg-slate-100 text-slate-600 border-slate-300",
};

const KEANGGOTAAN = {
  Jemaat: "bg-indigo-50 text-indigo-700 border-indigo-200",
  Simpatisan: "bg-teal-50 text-teal-700 border-teal-200",
  "Jemaat Pindahan": "bg-indigo-50 text-indigo-700 border-indigo-200",
  Tamu: "bg-purple-50 text-purple-700 border-purple-200",
};

export const StatusBadge = ({ value, type = "jemaat", className, testId }) => {
  const map = type === "keanggotaan" ? KEANGGOTAAN : STATUS_JEMAAT;
  const cls = map[value] || "bg-slate-100 text-slate-600 border-slate-300";
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border whitespace-nowrap",
        cls,
        className
      )}
    >
      {value}
    </span>
  );
};

export default StatusBadge;
